import { useState, useEffect } from 'react';
import { Zbor } from '../types/zbor';

export function useZborovi() {
  const [zborovi, setZborovi] = useState<Zbor[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/zborovi-improved.csv')
      .then(response => response.text())
      .then(text => {
        const lines = text.trim().split('\n');
        
        const data: Zbor[] = lines.slice(1).map(line => {
          // Handle CSV parsing with potential commas in values
          const values = line.match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g) || [];
          
          // Remove quotes from values and trim whitespace
          const cleanValues = values.map(val => val.replace(/^"|"$/g, '').trim());
          
          // Validate URLs - only include if they're proper URLs
          const instagram = cleanValues[3] && (
            cleanValues[3].startsWith('https://www.instagram.com/') || 
            cleanValues[3].startsWith('https://instagram.com/')
          ) ? cleanValues[3] : '';
          const chat = cleanValues[4] && (
            cleanValues[4].includes('invite.viber.com') ||
            cleanValues[4].startsWith('https://chat.whatsapp.com/') ||
            cleanValues[4].startsWith('https://t.me/')
          ) ? cleanValues[4] : '';
          
          return {
            regionMain: cleanValues[0] || '',
            mesto: cleanValues[1] || '',
            grad: cleanValues[2] || '',
            instagram,
            chat
          };
        });
        
        setZborovi(data);
        setIsLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setIsLoading(false);
      });
  }, []);

  return { zborovi, isLoading, error };
} 